<template>
  <page-content title="Ubah Data Pasien" :back-button="true">
    <br />
    <c-input-date id="first-visit-date" label="Tanggal Kunjungan Pertama">
      <datetime
        type="date"
        format="dd/LL/yyyy"
        v-model="userTmp.first_visit_date"
        value-zone="local"
      />
    </c-input-date>

    <c-input
      id="identity-number"
      label="No. Tanda Penduduk (KTP)"
      type="number"
      v-model="userTmp.id_card_number"
      :error="validations.idCardNumber.error"
      :error-message="validations.idCardNumber.message"
    />

    <c-input
      id="fullname"
      label="Nama Lengkap"
      v-model="userTmp.fullname"
      :error="validations.fullname.error"
      :error-message="validations.fullname.message"
    />

    <c-input
      id="date-of-birth"
      label="Tanggal Lahir"
      v-model="dateOfBirth"
      placeholder="Misal: 25/05/1990"
      :error="validations.dateOfBirth.error"
      :error-message="validations.dateOfBirth.message"
    />

    <c-input-radio label="Jenis Kelamin">
      <c-input-radio-item
        v-model="userTmp.gender"
        c-value="M"
        text="Pria"
        name="gender"
      />
      <c-input-radio-item
        v-model="userTmp.gender"
        c-value="F"
        text="Wanita"
        name="gender"
      />
    </c-input-radio>

    <c-input-select
      label="Agama"
      v-model="userTmp.religion"
      :options="religionList"
    />

    <c-input
      id="address"
      label="Alamat"
      type="textarea"
      rows="2"
      v-model="userTmp.address"
      :error="validations.address.error"
      :error-message="validations.address.message"
    />

    <c-input-select
      label="Pendidikan Terakhir"
      v-model="userTmp.education"
      :options="educationList"
    />

    <c-input
      id="profession"
      label="Pekerjaan"
      v-model="userTmp.profession"
      :error="validations.profession.error"
      :error-message="validations.profession.message"
    />

    <c-input-radio label="Status Perkawinan">
      <c-input-radio-item
        v-model="userTmp.marital_status"
        c-value="0"
        text="Tidak Menikah"
        name="maritalStatus"
      />
      <c-input-radio-item
        v-model="userTmp.marital_status"
        c-value="1"
        text="Menikah"
        name="maritalStatus"
      />
    </c-input-radio>

    <c-input-select
      label="Golongan Darah"
      v-model="userTmp.blood_type"
      :options="bloodList"
    />

    <c-input-select
      label="Departemen"
      v-model="userTmp.department_id"
      :options="departmentOptions"
    />

    <c-input
      id="phone"
      label="Nomor HP (WhatsApp)"
      v-model="userTmp.phone"
      :error="validations.phone.error"
      :error-message="validations.phone.message"
    />

    <button
      class="btn btn-block btn-primary"
      @click="doSubmit"
      v-if="!isLoading"
    >
      Simpan
    </button>
    <p align="center" v-else>
      <pulse-loader :loading="isLoading" size="10px" :color="colorPrimary" />
    </p>
  </page-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "profile-settings",
  data: function () {
    return {
      isLoading: false,
      userTmp: {},
      validations: {
        idCardNumber: {
          error: false,
        },
        fullname: {
          error: false,
        },
        dateOfBirth: {
          error: false,
        },
        address: {
          error: false,
        },
        profession: {
          error: false,
        },
        email: {
          error: false,
        },
        phone: {
          error: false,
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      pageLoading: "pageLoading",
      departments: "departments",
    }),
    departmentOptions: function () {
      const options = [];
      for (var i = 0; i < this.departments.length; i++) {
        options.push({
          value: this.departments[i].id,
          text: this.departments[i].name,
        });
      }
      return options;
    },
    dateOfBirth: {
      get: function () {
        return this.userTmp.date_of_birth
          ? this.formatDateToIndo(this.userTmp.date_of_birth)
          : null;
      },
      set: function (value) {
        this.userTmp.date_of_birth = this.formatDateFromIndo(value);
      },
    },
  },
  methods: {
    isFormValid: function () {
      // Reset the errors
      this.validations.idCardNumber.error = false;
      this.validations.fullname.error = false;
      this.validations.dateOfBirth.error = false;
      this.validations.address.error = false;
      this.validations.profession.error = false;
      this.validations.phone.error = false;

      if (this.isEmpty(this.userTmp.id_card_number)) {
        this.validations.idCardNumber.error = true;
        this.validations.idCardNumber.message = "No. KTP harus diisi.";
      }
      if (this.isEmpty(this.userTmp.fullname)) {
        this.validations.fullname.error = true;
        this.validations.fullname.message = "Nama Lengkap harus diisi.";
      }
      if (this.isEmpty(this.dateOfBirth)) {
        this.validations.dateOfBirth.error = true;
        this.validations.dateOfBirth.message = "Tanggal Lahir harus diisi.";
      }
      if (this.isEmpty(this.userTmp.address)) {
        this.validations.address.error = true;
        this.validations.address.message = "Alamat harus diisi.";
      }
      if (this.isEmpty(this.userTmp.profession)) {
        this.validations.profession.error = true;
        this.validations.profession.message = "Pekerjaan harus diisi.";
      }
      if (this.isEmpty(this.userTmp.phone)) {
        this.validations.phone.error = true;
        this.validations.phone.message = "Nomor HP (WhatsApp) harus diisi.";
      }

      for (const key in this.validations) {
        const field = this.validations[key];
        if (field["error"]) return false;
      }
      return true;
    },
    doSubmit: function () {
      if (this.isFormValid()) {
        this.isLoading = true;
        this.$store
          .dispatch("updateUser", this.userTmp)
          .then(() => {
            // Reset form
            this.isLoading = false;
            this.$toasted.success("Berhasil disimpan.");
          })
          .catch((error) => {
            const messages = error.response.data.message;
            if (messages.hasOwnProperty("id_card_number")) {
              this.validations.idCardNumber.error = true;
              this.validations.idCardNumber.message =
                messages.id_card_number[0];
            }
            if (messages.hasOwnProperty("fullname")) {
              this.validations.fullname.error = true;
              this.validations.fullname.message = messages.fullname[0];
            }
            if (messages.hasOwnProperty("date_of_birth")) {
              this.validations.dateOfBirth.error = true;
              this.validations.dateOfBirth.message = messages.date_of_birth[0];
            }
            if (messages.hasOwnProperty("address")) {
              this.validations.address.error = true;
              this.validations.address.message = messages.address[0];
            }
            if (messages.hasOwnProperty("profession")) {
              this.validations.profession.error = true;
              this.validations.profession.message = messages.profession[0];
            }
            if (messages.hasOwnProperty("phone")) {
              this.validations.phone.error = true;
              this.validations.phone.message = messages.phone[0];
            }
            this.isLoading = false;
          });
      }
    },
  },
  created: async function () {
    const id = this.$route.params.id;
    this.$store.dispatch("startPageLoading");
    this.$store.dispatch("getAllDepartments");
    this.$store
      .dispatch("getUser", id)
      .then((response) => {
        this.userTmp = response.data.data;
        this.$store.dispatch("stopPageLoading");
      })
      .catch(() => {
        this.$store.dispatch("stopPageLoading");
        this.$toasted.error("Gagal! Data tidak ditemukan.");
      });
  },
};
</script>
